
import React, { useEffect } from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { Container, Row, Col, Card } from "react-bootstrap";
import aboutImg from "../../assets/images/about/aboutimg.png";
import "../About/about.css";
import icons1 from "../../assets/images/icons/destination.png";
import icons2 from "../../assets/images/icons/best-price.png";
import icons3 from "../../assets/images/icons/quick.png";
import ClientReviews from "../../components/ClientReviews/ClientReviews";
import qr from "../../assets/images/qr.jpg";
import { Helmet } from "react-helmet-async";

const About = () => {
  useEffect(() => {
    document.title = "About us";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>One of the Best Travel Companies in India | About Shivay</title>
        <meta
          name="description"
          content="Discover why Shivay Tour and Travells is rated one of the best travel companies in India. Learn about our mission to create personalized and memorable travel experiences."
        />
        <meta name="keywords" content="best travel companies, travel services, Gujarat tours" />

        <link rel="canonical" href="https://www.shivaytourandtravells.com/about-us" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "TravelAgency",
            "name": "Shivay Tour and Travells",
            "description": "As one of the top travel companies in India, we offer unforgettable and budget-friendly custom trips across Gujarat and India.",
            "url": "https://www.shivaytourandtravells.com/",
            "logo": "https://www.shivaytourandtravells.com/logo.png",
            "telephone": "+91-9876543210",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "123 Travel Street",
              "addressLocality": "Surat",
              "addressRegion": "GJ",
              "postalCode": "395006",
              "addressCountry": "IN"
            },
            "sameAs": [
              "https://www.facebook.com/shivaytravels",
              "https://www.instagram.com/shivaytravels",
              "https://www.twitter.com/shivaytravels"
            ]
          }
          `}
        </script>
      </Helmet>
      <Breadcrumbs title="About us" pagename="About us" />

      <section className="py-5">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col md={8}>
              <div className="about-content">
                <h2 className="h2 font-bold pt-5 pb-3 custom-heading text-primary-emphasis">
                  Why We Strive to Be One of the Best Travel Companies in India
                </h2>

                <p className="body-text mb-3">
                  When you search for the best travel companies, you're looking for more than just a booking agent.
                  You're searching for a trusted partner to guide you, a local expert to inspire you,
                  and a dedicated team to ensure your precious travel days are perfect.
                </p>

                <p className="body-text mb-3">
                  Welcome to <strong>Shivay Tour & Travells</strong>. We're a team of passionate explorers, local storytellers,
                  and dedicated planners who believe that travel is the art of creating lifelong memories.
                </p>

                <h4 className="pt-4 fw-semibold custom-heading">Our Story: A Journey of Passion</h4>
                <p className="body-text mb-3">
                  Shivay Tour & Travells wasn't born in a boardroom; it was born from a deep, unwavering love
                  for the vibrant culture, hidden landscapes, and rich history of our home.
                  Over a decade ago, we started with a simple idea: to share the authentic,
                  soul-stirring beauty of Gujarat and India with the world.
                </p>
                <p className="body-text mb-3">
                  What began as a small dream has grown into a family of thousands of happy travelers —
                  but our founding purpose has never changed.
                </p>

                <h4 className="pt-4 fw-semibold custom-heading">Our Travel Philosophy</h4>
                <ul className="body-text ps-3">
                  <li><strong>Travel Should Be Personal:</strong> You are unique, and your journey should be too.
                    We craft itineraries that perfectly match your style, pace, and budget.</li>
                  <li><strong>Authenticity is Everything:</strong> Discover hidden gems, local flavors, and real culture — guided by passionate locals.</li>
                  <li><strong>Your Peace of Mind is Our Priority:</strong> From verified hotels to 24/7 support,
                    we handle every detail so you can enjoy a stress-free experience.</li>
                </ul>

                <h4 className="pt-4 fw-semibold custom-heading">Meet the Heart of Our Company</h4>
                <p className="body-text mb-3">
                  We are explorers, dreamers, and, most importantly, locals who are proud to share our home.
                  Our team knows the best times to visit temples, the most scenic routes, and the best shops for souvenirs.
                  We don't just plan your itinerary — we pour our hearts and local knowledge into it.
                </p>

                <h4 className="pt-4 fw-semibold custom-heading">Let's Start Your Next Chapter</h4>
                <p className="body-text mb-3">
                  Choosing a travel partner is an act of trust. We honor that trust by being more like a friend showing you their hometown
                  than a typical travel agency.
                </p>
                <p className="body-text mb-4">
                  Ready to create some unforgettable memories?
                  <a href="/contact-us" className="text-primary fw-semibold text-decoration-none"> Let's Start Crafting Your Adventure.</a>
                </p>

                <div className="about-image position-relative">
                  <img
                    src={aboutImg}
                    alt="about"
                    className="img-fluid rounded-5"
                  />
                  <div className="about-image-content position-absolute top-50 end-0 p-md-4 p-3 rounded-5 shadow-sm bg-dark bg-opacity-75">
                    <h3 className="h2 fw-bold text-white">
                      HOW WE ARE BEST FOR TRAVEL!
                    </h3>
                  </div>
                </div>

                {/* <h2 className="h2 font-bold pt-4 pb-2 custom-heading text-primary-emphasis">
                  Why Shivay Travels is Best for Your Journey?
                </h2> */}

                {/* <p className="body-text mb-2">
                  <strong>Shivay Tour & Travels</strong> is a trusted name for
                  <strong> unforgettable</strong> and{" "}
                  <strong>budget-friendly</strong> trips across Gujarat and
                  India.
                  <br />
                  Our goal is to make your journey{" "}
                  <strong>smooth, secure</strong>, and <strong>comfortable</strong>.
                </p>
                <p className="body-text mb-2">
                  Whether you wish to explore the serene temples of Somnath, the
                  desert beauty of Rann of Kutch, or the vibrant beaches of Diu
                  — we have the perfect package ready for you.
                </p>
                <p className="body-text mb-2">
                  Thousands of happy travelers have already trusted our
                  services. Now it’s your turn!
                </p> */}

                {/* <h4 className="pt-4 fw-semibold custom-heading">Our Mission</h4>
                <p className="body-text mb-2">
                  At Shivay Travels, our mission is to provide every traveler
                  with a personalized and hassle-free travel experience.
                </p> */}

                <h4 className="pt-3 fw-semibold custom-heading">
                  What Makes Us Unique?
                </h4>
                <ul className="body-text ps-3">
                  <li>✅ 10+ Years of Travel Expertise in Gujarat & India</li>
                  <li>✅ Custom Itineraries & Flexible Travel Plans</li>
                  <li>✅ 24x7 Support via Call or WhatsApp</li>
                  <li>✅ Verified Hotels & Local Guides for Comfort</li>
                </ul>

                {/* <h4 className="pt-4 fw-semibold custom-heading">
                  Meet Our Expert Team
                </h4> */}
                {/* <p className="body-text mb-3">
                  Our travel planners are passionate locals who know the hidden
                  gems of Gujarat and can craft the perfect plan for your next
                  journey.
                </p> */}

                <div
                  className="p-4 my-4 rounded-4 shadow-sm"
                  style={{
                    background: "linear-gradient(135deg, #e0f7fa, #fff)",
                  }}
                >
                  <h5 className="fw-bold text-success d-flex align-items-center gap-2">
                    <i className="bi bi-people-fill"></i> Over{" "}
                    <span className="text-primary">1,000+</span> Happy Customers
                  </h5>
                  <p className="body-text m-0">
                    Join thousands who explored Gujarat with Shivay Travels and
                    created unforgettable memories.
                  </p>
                </div>

                <div className="bg-white rounded-4 p-3 shadow-sm border-start border-4 border-success my-4">
                  <blockquote className="blockquote mb-0">
                    <p>"Travel is the only thing you buy that makes you richer."</p>
                  </blockquote>
                </div>
              </div>
            </Col>

            {/* RIGHT CARDS */}
            <Col md={4}>
              <div
                className="p-4 rounded-4 shadow-sm mb-4"
                style={{
                  background: "linear-gradient(135deg, #f0f4f8, #ffffff)",
                }}
              >
                <h5 className="fw-bold custom-heading mb-3">🚍 Our Travel Services</h5>
                <ul className="ps-3 body-text mb-3">
                  <li className="mb-2">✈️ <strong>Flight Ticket Booking</strong></li>
                  <li className="mb-2">🚆 <strong>Train Ticket Booking</strong></li>
                  <li className="mb-2">🚌 <strong>Bus Ticket Booking</strong></li>
                  <li className="mb-2">🌍 <strong>International Tours</strong></li>
                  <li className="mb-2">🏞️ <strong>Domestic Tours</strong></li>
                  <li className="mb-2">🏢 <strong>Corporate Tours</strong></li>
                  <li className="mb-2">🏨 <strong>Hotel Booking</strong></li>
                </ul>

                <div className="bg-white rounded-4 shadow-sm p-3 mb-3 border-start border-4 border-primary">
                  <p className="mb-1">
                    <strong>🎁 Tour Packages:</strong> Solo / Couple / Family / Group
                  </p>
                  <p className="mb-0"><strong>🚌 Vehicles:</strong></p>
                  <div className="custom-heading fw-bold">
                    5, 7, 9, 12, 14, 17, 20, 25, 33, 37, 40, 56 Seater
                  </div>
                </div>

                <div className="text-center mt-3">
                  <div className="d-inline-block p-2 bg-white rounded-4 shadow-sm">
                    <img
                      src={qr}
                      alt="Instagram QR"
                      className="img-fluid rounded-3"
                      style={{ maxWidth: "180px" }}
                    />
                  </div>
                  <p className="body-text mt-2 mb-0">
                    📸 Scan to follow us on Instagram
                  </p>
                  <div className="mt-3">
                    <button
                      className="btn btn-primary btn-lg rounded-pill px-4 shadow"
                      onClick={() => window.location.href = "/contact-us"}
                    >
                      📅 Book Now
                    </button>
                  </div>
                </div>
              </div>

              {[icons1, icons2, icons3].map((icon, idx) => (
                <Card className="border-0 shadow-sm rounded-3 mb-4" key={idx}>
                  <Card.Body className="text-center">
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <div
                        className="rounded-circle bg-white p-3 shadow-sm d-flex align-items-center justify-content-center"
                        style={{ width: 80, height: 80 }}
                      >
                        <img
                          src={icon}
                          alt={`icon-${idx}`}
                          className="img-fluid"
                          style={{ maxHeight: 40 }}
                        />
                      </div>
                    </div>
                    <Card.Title className="fw-bold h5 custom-heading">
                      {idx === 0
                        ? "50+ Destinations"
                        : idx === 1
                          ? "Best Price Guarantee"
                          : "Super Fast Booking"}
                    </Card.Title>
                    <p className="mb-2 body-text">
                      {idx === 0
                        ? "Explore beautiful places across Gujarat and India."
                        : idx === 1
                          ? "No hidden charges — just the best deals with satisfaction."
                          : "Get quick confirmations via WhatsApp or call."}
                    </p>
                  </Card.Body>
                </Card>
              ))}
            </Col>
          </Row>
        </Container>

        <ClientReviews />
      </section>

      <section className="py-5 bg-light">
        <Container>
          <h3 className="text-center fw-bold mb-4 custom-heading text-primary-emphasis">
            <i className="bi bi-geo-alt-fill me-2"></i> Our Location – Surat, Gujarat
          </h3>
          <div className="map-responsive rounded-4 overflow-hidden shadow-sm">
            <iframe
              title="Shivay Tour & Travels Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29756.341825760184!2d72.8506602!3d21.2103167!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f0033c9b25d%3A0x3b4b26f6090459cf!2sRiddhi%20Apartment!5e0!3m2!1sen!2sin!4v1752257354242!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </Container>
      </section>
    </>
  );
};

export default About;
